import React from 'react';
import { useNavigate } from 'react-router-dom';
//
import { useAuthContext } from '@components/auth';
import { Loader } from '@components';

const Home = () => {
  const { user, isVerified } = useAuthContext();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (isVerified) {
      navigate('/onboarding');
    }
  }, [isVerified, user]);

  return <Loader />;
};

export default Home;
